import { render } from "./resolution-title-input.vue?vue&type=template&id=f28e5270"
import script from "./resolution-title-input.vue?vue&type=script&lang=js"
export * from "./resolution-title-input.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__